import React from 'react'
import './Committee.css'
import user from '../../assets/images/user.webp'
import NarayanRao from '../../assets/images/secertary.webp'
import Sadagopan from '../../assets/images/sadagopan2.webp'
import Vidyashankar from '../../assets/images/vs.webp'
import Ashok from '../../assets/images/ashokmanaay.png'
import dean from '../../assets/images/dean.webp'
import adddean from '../../assets/images/add-dean.webp'
import Eishwar from '../../assets/images/bnm.webp'
import principal from '../../assets/images/principal.webp'
import ecehod from '../../assets/images/ece-yasha.webp'
import eeehod from '../../assets/images/venkatesha.webp'
import jyoti from '../../assets/images/jyothi-ece.webp'
import bindu from '../../assets/images/bindu.webp'
import Raksha from '../../assets/images/Mrs.-Raksha-S.webp'
import Prathyusha from '../../assets/images/Prathyusha-Pasupuleti.webp'
import priya from '../../assets/images/priya.webp'
import priyashree from '../../assets/images/priyashree.webp'
import keerti from '../../assets/images/keerti.webp'
import Arun from '../../assets/images/Arun-Balodi.jpg'
import shubha from '../../assets/images/shubha.webp'
import Charithra from '../../assets/images/Charithra.png'
import subodh from '../../assets/images/subodh.webp'
import manjunath from '../../assets/images/manjunath.webp'
import Lakshmi from '../../assets/images/Lakshmi.webp'
import rekha from '../../assets/images/rekha.webp'
import abhiskek from '../../assets/images/abhiskek appaji.webp'
import bhuvana from '../../assets/images/bhuvana.webp'
import ashwini from '../../assets/images/Ashwini.webp'
import karnam from '../../assets/images/karnam.webp'
import parameshachari from '../../assets/images/parameshachari.jpg'
import madhu from '../../assets/images/madhu.webp'
import Payal from '../../assets/images/Mrs.Payal.webp'
import Shruti from '../../assets/images/Mrs.-Shruti-V-joshi.webp'
import shesha from '../../assets/images/sheshaprasad.webp'
import debabrata from '../../assets/images/debabrata.webp'
import saritha from '../../assets/images/saritha.webp'
import sateesh from '../../assets/images/slsateesh.webp'
import vrunda from '../../assets/images/vrunda.webp'
import champa from '../../assets/images/champa.webp'
import Sumathi from '../../assets/images/Sumathi.webp'
import kiran from '../../assets/images/kiran.webp'
import Sameera from '../../assets/images/Sameera.webp'
import kruthi from '../../assets/images/kruthi.webp'
import priyadarshini from "../../assets/images/priyadarshini.webp"
import rashmi from '../../assets/images/rashmi.webp'
import smitha from '../../assets/images/smitha.webp'
import Kumar from '../../assets/images/Dr.-A-Kumar.webp'
import sujaya from '../../assets/images/sujaya.webp'
import sujith from '../../assets/images/sujith.webp'
import sunitha from '../../assets/images/sunitha.webp'
import AshwiniA from '../../assets/images/Ashwini-A.webp'
import Vyasaraj from '../../assets/images/vyasaraj.webp'
import sarala from '../../assets/images/sarala.webp'
import pramod from '../../assets/images/PramodKumar.webp'
import mohit from '../../assets/images/mohit.webp'
import Mukund from '../../assets/images/mukund.webp'
import kolla from '../../assets/images/kolla.webp'
import Sanjeevikumar from '../../assets/images/sanjeevikumar.webp'
import sainarayanan from '../../assets/images/sainarayanan.webp'
import anushree from '../../assets/images/anushree.webp'
import ayan from '../../assets/images/ayan.webp'
import nandha from '../../assets/images/Nandha.webp'

const Committee = () => {
    return (
        <div className="Committee">
            <h1 className="ch">Chairs</h1>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                <div className="container">
                    <h2 className="he">Chief Patron</h2>
                    <div className="content">
                        <div className="card">
                            <div className="card-content">
                                <div className="image">
                                    <img src={NarayanRao} alt="" />
                                </div>
                                <div className="name-profession">
                                    <span className="name">Sri. Narayan Rao R. Maanay</span>
                                    <span className="profession">Chairman, Governing Body, BNM Institute of Technology, Bengaluru</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <h2 className="he">Chief Mentor</h2>
                    <div className="content">

                        <div className="card">
                            <div className="card-content">
                                <div className="image">
                                    <img src={Sadagopan} alt="" />
                                </div>


                                <div className="name-profession">
                                    <span className="name">Dr. S. Sadagopan</span>
                                    <span className="profession">Former Director, IIIT Bangalore, Advisor, BNMIT</span>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <h2 className="he">Patrons</h2>
                    <div className="team">
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Vidyashankar} alt="" />
                                    </div>


                                    <div className="name-profession">
                                        <span className="name">Dr. S. Vidyashankar</span>
                                        <span className="profession">Vice Chancellor, Belagavi, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Ashok} alt="" />
                                    </div>


                                    <div className="name-profession">
                                        <span className="name">Sri. Ashok R. Maanay</span>
                                        <span className="profession">Joint-Secretary, BNMEI, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={dean} alt="" />
                                    </div>



                                    <div className="name-profession">
                                        <span className="name">Prof. T.J. Rama Murthy</span>
                                        <span className="profession">Director, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">

                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={adddean} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. S. Y. Kulkarni</span>
                                        <span className="profession">Additional Director & Principal, BNMIT, Bengaluru, India</span>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Eishwar} alt="" />
                                    </div>



                                    <div className="name-profession">
                                        <span className="name">Prof. Eishwar N. Maanay</span>
                                        <span className="profession">Dean, BNMIT, Bengaluru, India</span>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={principal} alt="" />
                                    </div>
                                    <div className="name-profession">
                                        <span className="name">Dr. Krishnamurthy G. N.</span>
                                        <span className="profession">Deputy Director, BNMIT, Bengaluru, India</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Steering Committee</h2>
                    <div className="team">
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={adddean} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. S. Y. Kulkarni</span>
                                        <span className="profession">Additional Director & Principal, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                      {/*  <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={debabrata} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Prof. Debabrata Das</span>
                                        <span className="profession">Ex Chair, IEEE Bengaluru Section, Director,
                                            IIIT-Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                </div>

                <div className="container">
                    <h2 className="he">General Chairs</h2>
                    <div className="team">
                    <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={ecehod} alt="" />
                                    </div>



                                    <div className="name-profession">
                                        <span className="name">Dr. Yasha Jyothi M. Shirur</span>
                                        <span className="profession">Prof & HoD, ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={eeehod} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Venkatesha K.</span>
                                        <span className="profession">Prof & HoD, EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={ecehod} alt="" />
                                    </div>



                                    <div className="name-profession">
                                        <span className="name">Dr. Yasha Jyothi M. Shirur</span>
                                        <span className="profession">Prof & HoD, ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Organizing Chairs</h2>
                    <div className="team">
                    <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={bindu} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Bindu S.</span>
                                        <span className="profession">Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={madhu} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Madhu S.</span>
                                        <span className="profession">Asso.Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={jyoti} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Jyoti R. Munavalli</span>
                                        <span className="profession">Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Technical Program Committee</h2>
                    <div className="team">
                    <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={rekha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Rekha P.</span>
                                        <span className="profession">Chair, Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={parameshachari} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name" style={{fontSize:'15px'}}>Dr.Parameshachari B D.</span>
                                        <span className="profession" style={{fontSize:'15px'}}>Co-Chair, Prof., Dept. of ECE, NMIT, Bengaluru SAC, Co-Chair, IEEE Bangalore Section.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={priyashree} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Priyashree S</span>
                                        <span className="profession">Co-Chair,Asso.Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={bhuvana} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Bhuvana Suganthi D.</span>
                                        <span className="profession">Co-Chair,Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={ayan} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Ayan Datta</span>
                                        <span className="profession">Co-Chair, IEEE Chair, CAS, Bengaluru Section, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                 
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Charithra} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Charithra C M.</span>
                                        <span className="profession">Co-Chair, Asso.Prof., MBA, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Kumar} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. A. Kumar</span>
                                        <span className="profession">Professor, EEE, BNM Institute of Technology, Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={ashwini} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Ashwini S. Savanth</span>
                                        <span className="profession">Asso.Prof., ECE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={keerti} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Keerti Kulkarni</span>
                                        <span className="profession">Co-Chair, Asso.Prof., ECE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={smitha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Smitha Gayathri</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sujaya} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Sujaya B L</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={priyadarshini} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Priyadarshini K Desai</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Lakshmi} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Lakshmi Bhaskar</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={anushree} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Anushree Ramanath</span>
                                        <span className="profession" style={{ fontSize: '12px' }}>Co-Chair for EE Stream, Technical Leader in Sustainability, Schnider Electric, San
                                            Francisco</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={champa} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Champa. P. N.</span>
                                        <span className="profession">Asso Prof., EEE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                       {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={user} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Ganesh R Naik</span>
                                        <span className="profession" style={{ fontSize: '12px' }}>Co-Chair for CS Stream, Research Theme Co-Lead-Sleep Neuroscience and Novel Biomarkers,
                                            Flinders University, Adelaide, Australia</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={user} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Noor Zaman</span>
                                        <span className="profession" style={{ fontSize: '12px', }}>Co-Chair for CS Stream, Professor, CSE , Program Director-PG
                                            Research Programmes Computer Science, Taylor’s University, Malaysia.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={anindya} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Sri. Anindya Saha</span>
                                        <span className="profession">Chair, IEEE ComSoc, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={nandha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Prof. T Nandha Kumar</span>
                                        <span className="profession">Co-Chair for EC Stream, Professor of Electronics, University of
                                        Nottingham, Malaysia</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}


                  {/*      <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={pramod} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Pramod Kumar</span>
                                        <span className="profession">Co-Chair for EC Stream, Professor, ECE, MIT, Manipal</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Sanjeevikumar} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Sanjeevikumar Padmanaban</span>
                                        <span className="profession" style={{ fontSize: '12px' }}>Co-Chair for EE Stream, SMIEEE, Professor Dept. of EE, IT & Cybernetics,
                                            University of South-Eastern, Norway</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                       {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={raghavendra} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Prof. Raghavendra Prasad S.G</span>
                                        <span className="profession" style={{ fontSize: '14px' }}>Vice Chair, IEEE Educational Society, Bangalore Chapter, RVCE</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}

                        {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={kolla} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Kolla Bhanu Prakash</span>
                                        <span className="profession" style={{ fontSize: '14px' }}>Prof., Faculty of Computer Science Engineering, K L
                                            University, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                     {/*   <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sainarayanan} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Sainarayanan Gopalakrishnan</span>
                                        <span className="profession">Technology Director, HCL Technologies, Chennai</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}


                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={bindu} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Bindu S.</span>
                                        <span className="profession">Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sudalai} alt="SSS" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Sudalai S Shunmugam</span>
                                        <span className="profession">Asso.Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}



                       {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={mohit} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Sri. Mohith Prabhu</span>
                                        <span className="profession">Senior Team Lead, Mathworks, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                       {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Mukund} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Sri. Mukund Dixit</span>
                                        <span className="profession">Senior Project Engineer, Honeywell Technology Solutions, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={priya} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Priya R. Sankpal</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        

                       

                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sujaya} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Sujaya B L</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}

                       

                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Financial Chairs</h2>
                    <div className="team">
                    <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={subodh} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Subodh Kumar Panda</span>
                                        <span className="profession">Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={manjunath} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Manjunath G. Asuti</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Kumar} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. A Kumar</span>
                                        <span className="profession">Professor, EEE, BNM Institute of Technology, Bengaluru.
</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Raksha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mrs. Raksha S</span>
                                        <span className="profession">Assistant Professor, EEE, BNM Institute of Technology, Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    

                     

                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Vyasaraj} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mr. Vyasaraj T</span>
                                        <span className="profession">Asst Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}

                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Publication Committee</h2>
                    <div className="team">

                    <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={jyoti} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Jyoti R. Munavalli</span>
                                        <span className="profession">Chair, Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Arun} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Arun Balodi</span>
                                        <span className="profession" style={{ fontSize: '13px' }}>Prof. and Chairman,Dept. of ECE,Dayananda Sagar University,Devarakaggalahalli, Harohalli,Kanakapura Road, Bengaluru.India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={shubha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Shubha Rao.K </span>
                                        <span className="profession" style={{}}>Co-Chair, Asso.Prof.,EEE, BNMIT Bengaluru,
                                            India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                       {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={priya} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Priya R. Sankapal</span>
                                        <span className="profession">Co-chair, Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={vrunda} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Vrunda Kusanur</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                      {/*  <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={priyashree} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Priyashree S</span>
                                        <span className="profession">Co-Chair, Asso.Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}

                       
                       {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={priyadarshini} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Priyadarshini K Desai</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={user} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Rajkumar Rajashekhar</span>
                                        <span className="profession">Prof., Vellore University, Vellore, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        */}

                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={rekha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Rekha P.</span>
                                        <span className="profession">Co-Chair, Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={bhuvana} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Bhuvana Suganthi D.</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={ashwini} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Ashwini S. Savanth</span>
                                        <span className="profession">Asso.Prof., ECE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}


                      

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={rashmi} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Rashmi S Bhaskar</span>
                                        <span className="profession">Asso.Prof., ECE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sunitha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Sunitha S V</span>
                                        <span className="profession">Asso.Prof., ECE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}

                        
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Sumathi} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Sumathi A.</span>
                                        <span className="profession">Asst Prof., ECE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={kruthi} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mrs. Kruthi Jayaram</span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={AshwiniA} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Ashwini A</span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={karnam} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mrs. Karnam Vasudha A</span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Prathyusha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Prathyusha Pasupuleti</span>
                                        <span className="profession">Asst Prof., Dept. of MBA, BNM Institute of Technology, Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="container">
                    <h2 className="he">Information Chairs</h2>
                    <div className="team">

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={shesha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr.N.Sheshaprasad</span>
                                        <span className="profession">Prof-ECE, HoD, Dept. of Humanities, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                      

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={kiran} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mr. Kiran K.N</span>
                                        <span className="profession">Asst Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sujith} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mr. Sujith T</span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sarala} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Sarala T</span>
                                        <span className="profession">Asst Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}

                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Sponsorship Committee Chairs</h2>
                    <div className="team">
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={saritha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Saritha Chakrasali</span>
                                        <span className="profession">Head, T & P, Professor, ISE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sateesh} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Prof. S. L. Sateesh Kumar</span>
                                        <span className="profession">Head, Teaching Learning Centre, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                       {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={vrunda} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Vrunda Kusunur</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Sameera} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Sri. Sameera P.</span>
                                        <span className="profession">Asst Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Shruti} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Shruti Joshi</span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Payal} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mrs. Payal Jindal</span>
                                        <span className="profession">Asst Prof. & Training and placement officer, Dept. of
Business Administration, BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', padding: '1rem' }}>
                <h2 className="he" style={{ marginTop: "40px" }}>Organizing Committee</h2>

                <ul className="liste">
                    <li><strong>Dr. Chayadevi M.L.</strong>, Prof & HoD, CSE, BNMIT, Bengaluru, India.</li>
                    <li><strong>Dr. S. Srividhya</strong>, Prof & HoD, ISE, BNMIT, Bengaluru, India.</li>
                    <li><strong>Dr. B. S. Anil Kumar</strong>, Prof & HoD, Mech. Engg, BNMIT, Bengaluru, India.</li>
                    <li><strong>Dr. Sheeba Selvam</strong>, Prof. & HoD, AIML, BNMIT, Bengaluru, India.</li>
                    <li><strong>Dr. L. Venkata Reddy</strong>, Prof. & HoD, Mathematics, BNMIT, Bengaluru, India.</li>
                    <li><strong>Dr. K. N. N. Prasad</strong>, Prof. & HoD, Physics, BNMIT, Bengaluru, India.</li>
                    <li><strong>Dr. Prathibha B. S.</strong>, Prof. & HoD, Chemistry, BNMIT, Bengaluru, India.</li> 
                    <li><strong>Dr. Mukund Sharma</strong>, Prof. & HoD, Dept. of Business Administration, BNMIT,Bengaluru, India.</li>
                    <li><strong>Mr. Sudharshan</strong>, Assistant Professor, ECE, BNMIT, Bengaluru, India.</li>
                    <li><strong>Smt. Sarala T</strong>, Assistant Professor, ECE, BNMIT, Bengaluru, India.</li>
                    <li><strong>Smt. Arpita Kulkarni</strong>, Assistant Professor, ECE, BNMIT, Bengaluru, India.</li>
                   {/*<li>Prof. Sumathi A., Associate Professor, ECE, BNMIT, Bengaluru, India.</li>
                    <li>Smt. Lakshmi Bhaskar, Assistant Professor, ECE, BNMIT, Bengaluru, India.</li>
                    
                    <li>Smt. Rohini T, Assistant Professor, ECE, BNMIT, Bengaluru, India.</li>
                    <li>Mr. Sameera P, Assistant Professor, ECE, BNMIT, Bengaluru, India.</li>*/}
                    
                </ul>
                <h2 className="he" style={{ marginTop: "40px" }}>Advisory Board Members</h2>
                <ul className="liste">
                  <li><strong>Dr. Prasant Misra</strong>, Chair-IEEE Bangalore Section, Professor, ECE, IISC, Bengaluru.</li> 
<li> <strong>Dr. P. Deepa Shenoy</strong>, Former Chair, IEEE Bangalore section. Professor, Department of
Computer Science & Engineering. UVCE, Bengaluru.</li> 
<li><strong>Dr. Omid Ansari</strong>, Penn State University, USA.</li>
<li><strong>Dr. Sheldon Williamson</strong>, Professor, Electrical, Computer and Software Engineering, Canada
Research Chair in Electric Energy Storage Systems for Transportation Electrification, Senior Member
– IEEE, Associate Editor for IEEE Transactions and Journals</li>
<li><strong>Sri. Srikanth Korse</strong>, R & D Engineer, Fraunhofer IIS, RWTH Aachen University, Germany.</li>
<li><strong>Sri. Vikas Vijaya Kumar</strong>, R & D Engineer, Tape-out Specialist, Stein bei Nürnberg, Bavaria,
Germany.</li>
<li><strong>Dr. Neelabh Kashyap</strong>, Principal Data Scientist, KONE, Finland.</li>
<li><strong>Sri. Ramesh Chinta</strong>, Principal member-Technical Staff, AT&T, USA.</li>
<li><strong>Sri. Samuel Tensingh</strong>, Associate Lecturer, University of Sydney, Australia.</li>
<li><strong>Dr. Shyam Vasudeva Rao</strong>, Founder & Director, Renalyx Health Systems, Forus & Rx DHP,
Bengaluru.</li>
<li><strong>Sri. Bhanuprakash</strong>, CoreEL Technologies, Bengaluru.</li>
<li><strong>Sri. Subramanya</strong>, SLN Technologies, Bengaluru.</li>
<li><strong>Dr. Shivananda Koteshwar</strong>, Vice President & EDA Group Head South Asia, Synopsys,
Bengaluru.</li>
<li><strong>Dr. Manjunath N. K.</strong>, Vice-Chancellor & Director Research, SVYASA-Deemed to be
University, Bengaluru.</li>
<li><strong>Dr. Usha Manjunath</strong>, Director, Institute of Health Management and Research (IHMR),
Bengaluru.</li>
<li><strong>Dr. Sanjeevikumar Padmanaban</strong>, Co-Chair for EE Stream, SMIEEE, Professor Dept. of EE, IT
& Cybernetics, University of South-Eastern, Norway.</li>
<li><strong>Dr. Sainarayanan Gopalakrishnan, Technology Director, HCL Technologies, Chennai.</strong></li>
<li><strong>Dr. Anand S</strong>, Director, Postgraduate Studies, Research & Innovation Department, College of
Banking & Financial Studies, Muscat, Oman.</li>
<li><strong>Sri. Mahesh Devagiri</strong>, Director & Co-Founder, Nyxses India Pvt Ltd, Bengaluru .</li>
                    {/*<li>Dr. Parameshachari B D, Professor, Dept. of ECE, NMIT, Bengaluru
                        SAC, Co-Chair, IEEE Bangalore Section.
                    </li>*/}
                    {/* <li>Sri. Mohith Prabhu, Senior Team Lead, Mathworks, Bengaluru.</li>
                    <li>Sri. Mukund Dixit, Senior Project Engineer, Honeywell Technology Solutions,
                        Bengaluru.</li>
                    <li>Dr. Kolla Bhanu Prakash, Professor, Faculty of Computer Science Engineering, K L University, India</li> */}
                </ul>
            </div>
        </div>
    )
}

export default Committee